module.exports = __webpack_public_path__ + "media/video201.5e40f2b9.mp4";